import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { getCitation } from './get.citations';
import { NumberedCitation } from '../../models';

/**
 * Use to get Numbered Citations/Refrences by Id
 * @returns {Observable<NumberedCitation>}
 */
export const getNumberedReferenceById = (props: { id: string }) =>
  createSelector(
    getCitation,
    (citations): NumberedCitation =>
      find(citations.references, (citation) => citation.citationId === props.id)
  );
